<template>
    <div class="outer-content blur foreground">
        <div id="dice_roll" v-bind:key="'diceRefresh' + diceRefresh">

            <b-container>
                <b-row>
                    <b-col class="dice-col" cols="6">
                        <p class="dice-title" @click="riverStateCheat" v-html="T('roll_flood_dice_header_river')"></p>
                        <DynamicImage :id="diceRollRiver" class="dice-image"></DynamicImage>
                        <h2 v-if="showResult" class="dice-result" v-html="diceRollRiverText"></h2>
                    </b-col>
                    <b-col class="dice-col" cols="6">
                        <p class="dice-title" @click="stormStateCheat" v-html="T('roll_flood_dice_header_ss')"></p>
                        <DynamicImage :id="diceRollStorm" class="dice-image dice-right"></DynamicImage>
                        <h2 v-if="showResult" class="dice-result" v-html="diceRollStormText"></h2>
                    </b-col>
                </b-row>
            </b-container>

            <AudioClip v-if="isMuted == false" :autoplay="true" id="Dice_idea1" :overrideVolume="1"></AudioClip>

            <template v-if="showResult">
                <p class="dice_result_p" v-html="diceResultText"></p>
                <button class="dice_continue_BTN" @click="$emit('next-clicked')" v-html="T('button_continue')"></button>
            </template>

            <div class="icon-info" @click="showInfo = true"></div>

        </div>

        <DialogueBox v-if="showInfo" :left="558" :top="207" :width="502" :height="321" :darken="true">
            <div class="info-header" v-html="T('dice_rolls')"></div>
            <div class="info-text" v-html="T('dice_rolls_text')"></div>
            <div class="close-dialogue-box" @click="showInfo = false"></div>
            <div class="facilitator-tick"></div>
        </DialogueBox>

    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import DynamicImage from './DynamicImage.vue';
import { T } from '@/App.vue';
import AudioClip from './AudioClip.vue';
import { stormDamageLevel } from '../../../shared_fca/game';
import DialogueBox from './DialogueBox.vue';

export default Vue.extend({
    name: 'DiceRollPopUp',
    props: {
        isHost: Boolean, //Used for test cheating
        riverStage: Number,
        stormStage: Number,
        isMuted: Boolean,
        round: Number,
        diceResultText: String,
    },
    data() {
        return {
            showResult: false,
            diceRefresh: 0,
            showInfo: false,
        };
    },
    mounted() {
        setTimeout(() => {
            this.showResult = true;
        }, 2500);
    },
    computed: {

        diceRollRiver: {
            cache: false,
            get(): string {
                return "diceRiver" + (this.riverStage + 1);
            }
        },

        diceRollStorm: {
            cache: false,
            get(): string {
                return "diceStorm" + this.stormStage;
            }
        },

        diceRollRiverText: {
            cache: false,
            get(): string {
                return T("roll_flood_header_result_" + (this.riverStage + 1));
            }
        },

        diceRollStormText: {
            cache: false,
            get(): string {
                switch (this.stormStage) {
                    case stormDamageLevel.level1:
                        return T("roll_flood_header_result_4");
                    case stormDamageLevel.level2:
                        return T("roll_flood_header_result_5");
                    case stormDamageLevel.cyclone:
                        return T("roll_flood_header_result_6");
                    default:
                        return ""; //Unknown/none
                }
            }
        },

    },
    components: {
        DynamicImage,
        AudioClip,
        DialogueBox
    },
    methods: {
        T(key: string): string {
            return T(key);
        },

        riverStateCheat() {
            switch (this.riverStage) {
                case 0:
                    this.$emit("river-state-cheat", 1);
                    break;
                case 1:
                    this.$emit("river-state-cheat", 2);
                    break;
                case 2:
                    this.$emit("river-state-cheat", 0);
                    break;
            }
            this.diceRefresh++;
        },

        stormStateCheat() {
            switch (this.stormStage) {
                case 1:
                    this.$emit("storm-state-cheat", 2);
                    break;
                case 2:
                    this.$emit("storm-state-cheat", 4);
                    break;
                case 4:
                    this.$emit("storm-state-cheat", 1);
                    break;
            }
            this.diceRefresh++;
        }
    }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.facilitator-tick {
    left: 433px;
    top: -32px;
}

#dice_roll {
    position: absolute;
    background-color: white;
    width: 752px;
    height: 583px;
    top: 149px;
    border-radius: 29px;
}

.dice-col {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.dice-title {
    color: #636252;
    font-family: Rubik;
    font-size: 30px;
    font-weight: 800;
    line-height: 35.55px;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-top: 45px;
}

.dice-image {
    width: 244.45px;
    height: 257px;
    pointer-events: none;
    transform: scale(1.75);
}

.dice-right {
    position: relative;
    left: 17.5px;
}

.dice-result {
    font-family: Rubik;
    font-size: 30px;
    font-weight: 800;
    line-height: 35.55px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #636252;
    margin-top: 21px;
}

.dice_result_p {
    height: 19px;
    width: 100%;
    color: #333333;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    text-align: center;
    position: absolute;
    top: 440px;
    padding-left: 140px;
    padding-right: 140px;
}

.dice_continue_BTN {
    height: 40px;
    width: 100px;
    border-radius: 8px;
    border-style: none;
    background-color: #B2CD30;
    color: #636252;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    position: absolute;
    top: 516px;
    left: 331px;
    padding: 0px;
}

.icon-info {
    cursor: pointer;
    width: 18px;
    height: 18px;
    background-image: url("../assets-fca/UI/icon_info.svg");
    position: absolute;
    right: 18px;
    top: 20px;
}

.close-dialogue-box {
    cursor: pointer;
    background-image: url("../assets-fca/UI/close_gray.svg");
    width: 16px;
    height: 16px;
    top: 39px;
    right: 24px;
    position: absolute;
}

.info-header {
    position: absolute;
    top: 40px;
    left: 29px;
    color: #636252;
    font-family: Rubik;
    font-weight: 800;
    font-size: 16px;
    line-height: 18.96px;
    letter-spacing: 0px;
}

.info-text {
    position: absolute;
    top: 79px;
    left: 29px;
    color: #333333;
    width: 448px;
    font-family: Rubik;
    font-weight: 400;
    font-size: 16px;
    line-height: 18.96px;
    letter-spacing: 0px;
}
</style>